import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const FaceSad = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width={computedSize}
      height={computedSize}
      fill={color}
      {...props}
    >
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path
          stroke="#344054"
          d="M2.293 10c0 5.78 1.927 7.708 7.708 7.708s7.709-1.928 7.709-7.709S15.782 2.291 10 2.291 2.293 4.219 2.293 9.999"
          clipRule="evenodd"
        />
        <path
          stroke="#344054"
          d="M11.67 13.332c-.935-1.105-2.391-1.118-3.334 0"
        />
        <path stroke="#FF6A00" d="M12.92 8.333V6.666M7.083 8.333V6.666" />
      </g>
    </svg>
  );
};
export default FaceSad;
